module.exports = __webpack_public_path__ + "img/UTFRED.ff116f23.png";